export enum SalesScope {
  SEARCH = 'SEARCH',
  PIA_AUCTION = 'PIA_AUCTION',
  BOOKMARKS = 'BOOKMARKS',
  MY_AUCTIONS = 'MY_AUCTIONS',
  FINISHED_OFFERS = 'FINISHED_OFFERS',
}
